import eventRegistry from "../common/event-registry";
import DownPeerConnection from "../main/peer-connection/down-peer-connection";
import logger from "../common/logger";
import { generateId } from '../common/common'
import { MediaType } from '../common/enums'
// import store from '../main/util/store'
import { tracelog } from "../common/common";

const getLiveInfo  = async (accessUrl, callback, n = 0) => {
  if (n === 3) {
    return eventRegistry.trigger('onError', {code: 2, msg: 'get address failed'})
  }
  let url = accessUrl
  const res = await fetch(url, { credentials: 'omit' });
  const resJson = await res.json();
  logger.info(resJson.code)
  if (resJson.code === 606000008 || resJson.code === 601032001 || resJson.code === 601032002){
    logger.info('throw Error')
    eventRegistry.trigger('onError', {code: 1, msg: 'system busy'})
  } else if(resJson.code === 0) {
    callback && callback(resJson.result)
  } else {
    setTimeout(() => {
      getLiveInfo(accessUrl, callback, ++n)
    }, 3000)
  }
}
class LiveEngine {
  constructor (options) {
    options = options || {}
    this.guid = generateId()
    this.accessAddr = null
    this.appId = null
    this.companyId = null
    this.downPeerConnection = null
    this.videoEle = null
    this.wsAddr =  null
    this.downPcMap = new Map()
    this.liveRoomId = options.liveRoomId
    this.params = null // 参数
    this.bindIdMaps = new Map() // 保存地址与bindId的映射

    eventRegistry.on('onRemoteMediaAdd', (params) => {
     let pc = this.downPcMap.get(params.bindId)
     this.videoEle.srcObject = pc.mediaStream
    })
  }
  /**
   * 恢复流
   * @param {*} params 
   */
  restoreDownTrack (params) {
    if (params.mediaType === MediaType.VIDEO) {
      this.startReceiveMedia (this.fspUrl, this.videoEle, {
        video: true,
        audio: false
      })
    } else {
      this.startReceiveMedia (this.fspUrl, this.videoEle, {
        video: false,
        audio: true
      })
    }
  }
  /**
   * 删除
   * @param {}} bindId 
   */
  @tracelog
  removeDownPc (bindId) {
    logger.log('delete down peerconnetion: ' + bindId)
    this.downPeerConnection = null
    this.bindIdMaps.delete(this.fspUrl)
    if (!this.downPcMap.delete(bindId)) {
      logger.warn("Cannot find down peer connection by bindId: " + bindId);
    }
  }
  startReceiveMedia (fspUrl, ele, videoParams) {
    this.fspUrl = fspUrl
    getLiveInfo(`${fspUrl}?service_type=25&&live_room_id=${this.liveRoomId}`, (params) => {
      let wsAddrs = params.address
      let accessAddrs = wsAddrs.indexOf(';') > -1 ? wsAddrs.split(';') : [wsAddrs]
      this.wsAddr = null
      accessAddrs.map((item) => {
        if (item.indexOf('ws') > -1) {
          this.wsAddr = item
        }
      })
      this.videoEle = ele
      this.accessAddr = params.address
      this.audio_stream_id = params.audio_stream_id
      this.video_stream_id = params.video_stream_id
      this.audio_stream_token = params.audio_stream_token
      this.video_stream_token = params.video_stream_token
      this.bindId = this.bindIdMaps.get(fspUrl)
      if (!this.bindId) {
        this.bindId = generateId()
        this.bindIdMaps.set(fspUrl, this.bindId)
      }

      this.downPeerConnection = this.downPcMap.get(this.bindId)
      if (!this.downPeerConnection) {
        this.downPeerConnection = new DownPeerConnection(this.bindId, this)
        this.downPcMap.set(this.bindId, this.downPeerConnection)
      }
      console.log(this.bindId)
      console.log(this.downPcMap)
        // 开始接收视频
      if (this.video_stream_id && videoParams.video) {
        this.downPeerConnection.startRecvStream({
          userId: 0,
          mediaType: 2,
          mediaId: 0,
          streamId: this.video_stream_id,
          streamServer: this.wsAddr, 
          streamToken: this.video_stream_token
        })
      }
      if (this.audio_stream_id && videoParams.audio) {
        this.downPeerConnection.startRecvStream({
          userId: 0,
          mediaType: 1,
          mediaId: 0,
          streamId: this.audio_stream_id,
          streamServer: this.wsAddr, 
          streamToken: this.audio_stream_token
        })
      }
    })
    return {
      stop (videoParams) {
        if (videoParams === undefined) {
          this.downPeerConnection.stopRecvStream({
            userId: 0,
            mediaType: MediaType.AUDIO,
            mediaId: 0
          });
          this.downPeerConnection.stopRecvStream({
            userId: 0,
            mediaType: MediaType.VIDEO,
            mediaId: 0
          });
          return
        }
        if (videoParams.video) {
          this.downPeerConnection.stopRecvStream({
            userId: 0,
            mediaType: MediaType.VIDEO,
            mediaId: 0
          });
        }
        if (videoParams.audio) {
          this.downPeerConnection.stopRecvStream({
            userId: 0,
            mediaType: MediaType.AUDIO,
            mediaId: 0
          });
        }
      }
    }
  }
  subEvent () {
    console.log("Subscribe event: ", arguments[0]);
    eventRegistry.on(...arguments)
  }
  /**
   * 取消订阅事件，参数为空则为取消订阅所有事件
   */
  unsubEvent () {
    console.log("Unsubscribe event: ", arguments[0]);
    eventRegistry.off(...arguments);  
  }
  destory () {
    this.downPeerConnection && this.downPeerConnection.close()
    eventRegistry.off()
  }
}

export default LiveEngine